<ul class="tree-view">
  <li [ngClass]="{ closed: !root.expanded }">
    <a class="toggle clickable" (click)="expand(root)">
      <t-icon *ngIf="root.expanded" name="remove_circle_outline"></t-icon>
      <t-icon *ngIf="!root.expanded" name="add_circle_outline"></t-icon>
    </a>
    <a class="text">
      <span>{{ root.label }}</span>
    </a>
    <ul *ngIf="root.items.length > 0 || root.documents.length > 0">

      <li *ngFor="let document of root.documents">
        <a class="toggle">
          <t-icon name="attach_file"></t-icon>
        </a>
        <a class="text clickable" (click)="onDownload(root, document)">
          <span>{{ document.name }}</span>
        </a>
        <a class="action clickable" (click)="onDownload(root, document)">
          <t-icon name="file_download" title="Télécharger"></t-icon>
        </a>
      </li>

      <li *ngFor="let item of root.items" [ngClass]="{ closed: !item.expanded }">
        <a class="toggle clickable" (click)="expand(item)">
          <t-icon *ngIf="item.expanded" name="remove_circle_outline"></t-icon>
          <t-icon *ngIf="!item.expanded" name="add_circle_outline"></t-icon>
        </a>
        <a class="text">
          <span>{{ item.label }}</span>
        </a>
        <ul *ngIf="item.items.length > 0">
          <li *ngFor="let item of item.items" [ngClass]="{ closed: !item.expanded }">
            <a class="toggle clickable" (click)="expand(item)">
              <t-icon *ngIf="item.expanded" name="remove_circle_outline"></t-icon>
              <t-icon *ngIf="!item.expanded" name="add_circle_outline"></t-icon>
            </a>
            <a class="text">
              <span>{{ item.label }}</span>
            </a>
            <ul *ngIf="item.documents.length > 0">
              <li *ngFor="let document of item.documents">
                <a class="toggle">
                  <t-icon name="attach_file"></t-icon>
                </a>
                <a class="text clickable" (click)="onDownload(item, document)">
                  <span>{{ document.name }}</span>
                </a>
                <a class="action clickable" (click)="onDownload(item, document)">
                  <t-icon name="file_download" title="Télécharger"></t-icon>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>